import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import DatePicker from 'react-datepicker2';

export default class CattleFatteningPerformance extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            systemModuleId: 42,
            moduleAccessStatus: 1,
            filters: {
                fromDate: '',
                toDate: '',
                fromDateConverted: '',
                toDateConverted: '',
            },
            page: 1,
            per_page: 30,
            phrase: '',
            controllerName: 'report',
            menuId: 244
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData(null, 'farm/cattle-fattening-performance');
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">گزارش پرواربندی</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.refreshData(e, "stuff/inventoryturnover", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e, "stuff/inventoryturnover")}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.fromDate = e;
                                                        this.state.filters.fromDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.fromDate)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.toDate = e;
                                                        this.state.filters.toDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.toDate)}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e, "stuff/inventoryturnover")} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ ردیفی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th><span className="sub-text text-center">شماره گوشواره</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">وزن خرید</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">تاریخ خرید</span></th>
                                                <th><span className="sub-text text-center">وزن خوراک مصرفی</span></th>
                                                <th><span className="sub-text text-center">دفعات خوراک دهی</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">وزن فروش</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">تاریخ فروش</span></th>
                                                <th><span className="sub-text text-center">وزن پروار یافته</span></th>
                                                <th><span className="sub-text text-center">تعداد روز</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.records.map((record, index) =>
                                            <tr>
                                                <td>
                                                    <span className="sub-text text-center">{record.name}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.buyAmount)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{record.buyDateString}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.useAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.useCount)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.saleAmount)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{record.saleDateString}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.distAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.dayCount)}</span>
                                                </td>
                                            </tr>
                                            )}
                                            <tr style={{ "background-color": "beige" }}>
                                                <td>
                                                    <b className="sub-text text-center">مجموع</b>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.totalBuyAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.totalUseAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.totalSaleAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.totalDistAmount)}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}